export enum VehicleGarageEnum {
  HOME = 'HOME',
  HOME_AND_WORKPLACE = 'HOME_AND_WORKPLACE',
  WORKPLACE = 'WORKPLACE',
  NONE = 'NONE',
}

export const getVehicleGarageLabel = (value: VehicleGarageEnum): string => {
  switch (value) {
    case VehicleGarageEnum.HOME:
      return $localize`Maison`;
    case VehicleGarageEnum.HOME_AND_WORKPLACE:
      return $localize`Maison et travail`;
    case VehicleGarageEnum.WORKPLACE:
      return $localize`Travail`;
    case VehicleGarageEnum.NONE:
      return $localize`Aucun des deux`;
    default:
      return '';
  }
};
